import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import Header from "common-components/Header";
import Container from "common-components/Container";
import StyledLink from "common-components/StyledLink";

class AppealConfirmation extends Component {

  componentDidMount() {
    if (checkNestedObject(this.props, "location", "state", "appealConfirmationContent")) {
      this.props.setA11yContent(
        "appeal confirmation",
        this.props.location.state.appealConfirmationContent.sc_pagetitle
      );
    }

    if (checkNestedObject(this.props, "pageContent", "breadCrumbs", "landingPage")) {
      const { landingPage, requestHistory, submitAppeal, appealConfirmation } = this.props.pageContent.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/your-data" },
        { label: requestHistory, path: "/privacy/secure/request-history" },
        { label: submitAppeal, path: "/privacy/secure/submit-appeal" },
        { label: appealConfirmation, path: "/privacy/secure/appeal-confirmation" }
      ]);
    }

  }

  render() {

    if (!checkNestedObject(this.props, "location", "state", "appealConfirmationContent")) {
      return <Redirect to="/privacy/secure/your-data" />;
    }


    const { appealConfirmationContent, nextRoute } = this.props.location.state
    const {
      section_title,
      buttons,
      section_description
    } = appealConfirmationContent;


    return (
      <Container>
        <div style={{ maxWidth: "596px" }}>
          <Header>{convertStringToElements(section_title)}</Header>
          <Div>{convertStringToElements(section_description)}</Div>
          <StyledLink
            background={buttons[0].type}
            style={{ marginTop: "16px" }}
            to={nextRoute}
          >
            {buttons[0].text}
          </StyledLink>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent
}) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent, setBreadcrumbList }
)(AppealConfirmation);

const Div = styled.div`
  /*margin: 40px 0;*/
  margin-top: 28px;
  margin-bottom:55px;

  p {
    margin: 12px 0;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }
`;
